module.exports = __webpack_public_path__ + "img/2c.949e4495.svg";